"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectPayIn = void 0;
class DirectPayIn {
    payInId;
    status;
    result;
    resultCode;
    resultMessage;
    tag;
}
exports.DirectPayIn = DirectPayIn;
//# sourceMappingURL=DirectPayIn.js.map